import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useRef as l, useEffect as i } from "react";
import { useEvent as r } from './use-event.js';
var u = Symbol();

function T(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return Object.assign(t, _defineProperty({}, u, n));
}

function y() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  var n = l(t);
  i(function () {
    n.current = t;
  }, [t]);
  var c = r(function (e) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = n.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var o = _step.value;
        o != null && (typeof o == "function" ? o(e) : o.current = e);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
  return t.every(function (e) {
    return e == null || (e == null ? void 0 : e[u]);
  }) ? void 0 : c;
}

export { T as optionalRef, y as useSyncRefs };